import { SxProps, Theme } from "@mui/material/styles";
import { formDialogStyles } from "@homesusa/layout";

export const newUserModalStyles: Record<string, SxProps<Theme>> = {
  dialog: formDialogStyles,
  form: { display: "flex", flexDirection: "column", minHeight: 0 },
  content: { display: "flex", flexDirection: "column", gap: 2 },
  submitButton: {
    "& .MuiCircularProgress-root": { color: "primary.main" }
  },
  fields: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: 2,
    "@media (min-width: 768px)": {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
  }
};
